/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */

import SouscriptionWaiverStages from './souscriptionWaiverStages/client/SouscriptionWaiverStages';
import SouscriptionSupportingDocumentsGroupProtection from './souscriptionSupportingDocumentsGroupProtection/client/SouscriptionSupportingDocumentsGroupProtection';
import SouscriptionSupportingDocuments from './souscriptionSupportingDocuments/client/SouscriptionSupportingDocuments';
import SouscriptionRecapGroupProtection from './souscriptionRecapGroupProtection/client/SouscriptionRecapGroupProtection';
import SouscriptionRecap from './souscriptionRecap/client/SouscriptionRecap';
import SouscriptionPricing from './souscriptionPricing/client/SouscriptionPricing';
import SouscriptionPaymentRefundGroupProtection from './souscriptionPaymentRefundGroupProtection/client/SouscriptionPaymentRefundGroupProtection';
import SouscriptionPaymentRefund from './souscriptionPaymentRefund/client/SouscriptionPaymentRefund';
import SouscriptionInformations from './souscriptionInformations/client/SouscriptionInformations';
import SouscriptionCustomerGrantees from './souscriptionCustomerGrantees/client/SouscriptionCustomerGrantees';
import SouscriptionCompanyGroupProtection from './souscriptionCompanyGroupProtection/client/SouscriptionCompanyGroupProtection';
import SouscriptionCompany from './souscriptionCompany/client/SouscriptionCompany';
import SouscriptionActivePolicyGroupProtection from './souscriptionActivePolicyGroupProtection/client/SouscriptionActivePolicyGroupProtection';
import SouscriptionActivePolicy from './souscriptionActivePolicy/client/SouscriptionActivePolicy';
import SimulationWarrantiesGroupProtection from './simulationWarrantiesGroupProtection/client/SimulationWarrantiesGroupProtection';
import SimulationRecapGroupProtection from './simulationRecapGroupProtection/client/SimulationRecapGroupProtection';
import SimulationRecap from './simulationRecap/client/SimulationRecap';
import SimulationProduct from './simulationProduct/client/SimulationProduct';
import SimulationPricingsSelfWorker from './simulationPricingsSelfWorker/client/SimulationPricingsSelfWorker';
import SimulationPricingsIndividualHealth from './simulationPricingsIndividualHealth/client/SimulationPricingsIndividualHealth';
import SimulationPricingGroupHealth from './simulationPricingGroupHealth/client/SimulationPricingGroupHealth';
import SimulationPricingsDailyBenefit from './simulationPricingsDailyBenefit/client/SimulationPricingsDailyBenefit';
import SimulationPavillonInformation from './simulationPavillonInformation/client/SimulationPavillonInformation';
import SimulationOfferGroupProtection from './simulationOfferGroupProtection/client/SimulationOfferGroupProtection';
import SimulationNeedsGroupProtection from './simulationNeedsGroupProtection/client/SimulationNeedsGroupProtection';
import SimulationNeeds from './simulationNeeds/client/SimulationNeeds';
import SimulationEffectDate from './simulationEffectDate/client/SimulationEffectDate';
import SimulationDemographyGroupProtection from './simulationDemographyGroupProtection/client/SimulationDemographyGroupProtection';
import SimulationDemography from './simulationDemography/client/SimulationDemography';
import SimulationCustomerGrantees from './simulationCustomerGrantees/client/SimulationCustomerGrantees';
import SimulationContractDataGroupProtection from './simulationContractDataGroupProtection/client/SimulationContractDataGroupProtection';
import SimulationCompanyGroupProtection from './simulationCompanyGroupProtection/client/SimulationCompanyGroupProtection';
import SimulationCompany from './simulationCompany/client/SimulationCompany';

const views = {

  SOUSCRIPTION_WAIVER_STAGES: SouscriptionWaiverStages,
  SOUSCRIPTION_SUPPORTING_DOCUMENTS_GROUP_PROTECTION: SouscriptionSupportingDocumentsGroupProtection,
  SOUSCRIPTION_SUPPORTING_DOCUMENTS: SouscriptionSupportingDocuments,
  SOUSCRIPTION_RECAP_GROUP_PROTECTION: SouscriptionRecapGroupProtection,
  SOUSCRIPTION_RECAP: SouscriptionRecap,
  SOUSCRIPTION_PRICING: SouscriptionPricing,
  SOUSCRIPTION_PAYMENT_REFUND_GROUP_PROTECTION: SouscriptionPaymentRefundGroupProtection,
  SOUSCRIPTION_PAYMENT_REFUND: SouscriptionPaymentRefund,
  SOUSCRIPTION_INFORMATIONS: SouscriptionInformations,
  SOUSCRIPTION_CUSTOMER_GRANTEES: SouscriptionCustomerGrantees,
  SOUSCRIPTION_COMPANY_GROUP_PROTECTION: SouscriptionCompanyGroupProtection,
  SOUSCRIPTION_COMPANY: SouscriptionCompany,
  SOUSCRIPTION_ACTIVE_POLICY_GROUP_PROTECTION: SouscriptionActivePolicyGroupProtection,
  SOUSCRIPTION_ACTIVE_POLICY: SouscriptionActivePolicy,
  SIMULATION_WARRANTIES_GROUP_PROTECTION: SimulationWarrantiesGroupProtection,
  SIMULATION_RECAP_GROUP_PROTECTION: SimulationRecapGroupProtection,
  SIMULATION_RECAP: SimulationRecap,
  SIMULATION_PRODUCT: SimulationProduct,
  SIMULATION_PRICINGS_SELF_WORKER: SimulationPricingsSelfWorker,
  SIMULATION_PRICINGS_INDIVIDUAL_HEALTH: SimulationPricingsIndividualHealth,
  SIMULATION_PRICINGS_GROUP_HEALTH: SimulationPricingGroupHealth,
  SIMULATION_PRICINGS_DAILY_BENEFIT: SimulationPricingsDailyBenefit,
  SIMULATION_PAVILLON_INFORMATION: SimulationPavillonInformation,
  SIMULATION_OFFER_GROUP_PROTECTION: SimulationOfferGroupProtection,
  SIMULATION_NEEDS_GROUP_PROTECTION: SimulationNeedsGroupProtection,
  SIMULATION_NEEDS: SimulationNeeds,
  SIMULATION_EFFECT_DATE: SimulationEffectDate,
  SIMULATION_DEMOGRAPHY_GROUP_PROTECTION: SimulationDemographyGroupProtection,
  SIMULATION_DEMOGRAPHY: SimulationDemography,
  SIMULATION_CUSTOMER_GRANTEES: SimulationCustomerGrantees,
  SIMULATION_CONTRACT_DATA_GROUP_PROTECTION: SimulationContractDataGroupProtection,
  SIMULATION_COMPANY_GROUP_PROTECTION: SimulationCompanyGroupProtection,
  SIMULATION_COMPANY: SimulationCompany
};

export default views;
